export default class Widget {
    constructor (dto) {
        this.id = 0
        this.widgetId = 0
        this.name = ''
        this.x = 0
        this.y = 0
        this.h = 0
        this.w = 0
        this.i = 0
        this.settings = null

        if (dto) {
            this.id = dto.Id
            this.name = dto.WidgetName
            this.widgetId = dto.WidgetID
            this.x = dto.PositionX
            this.y = dto.PositionY
            this.h = dto.Heigth
            this.w = dto.Width
            this.i = dto.Index
            this.settings = dto.Settings
        }
    }

    toDto () {
        return {
            Id: this.id,
            WidgetName: this.name,
            WidgetID: this.widgetId,
            PositionX: this.x,
            PositionY: this.y,
            Heigth: this.h,
            Width: this.w,
        }
    }
}
